import { BYTES_PER_KB } from '@federa/const/operations';

/** What an UNMEASURABLE size reads as. Zero, a negative and a non-finite all answer THIS rather than a NaN, a `-` or
 *  an empty string: the three are different causes with one honest rendering, and they must not drift apart. */
const UNMEASURABLE_SIZE = '0 B';

/** Format a file size in human-readable form (`0 B`, `512.0 B`, `1.5 KB`, `2.3 MB`, `1.0 GB`). */
export function formatFileSize(bytes: number, decimals: number = 1): string {
	if (bytes === 0) return UNMEASURABLE_SIZE;
	if (bytes < 0) return UNMEASURABLE_SIZE;
	if (!Number.isFinite(bytes)) return UNMEASURABLE_SIZE;

	const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
	const i = Math.min(Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KB)), sizes.length - 1);

	return `${(bytes / Math.pow(BYTES_PER_KB, i)).toFixed(decimals)} ${sizes[i] ?? 'B'}`;
}
